import { z } from "zod";
import { request } from "@/shared/api/http-client";
import { apiEnvelope } from "@/shared/api/api-contract";
import { AI_CAPABILITIES } from "@/shared/model/ai-enums";
import type { AiCapability } from "@/shared/model/ai-enums";

const conditionValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.array(z.union([z.string(), z.number(), z.boolean()])),
  z.null(),
]);

export const memberPricingRuleSchema = z.object({
  pricingRuleId: z.number().int(),
  modelId: z.number().int(),
  modelName: z.string().nullish(),
  capability: z.enum(AI_CAPABILITIES),
  condition: z.record(z.string(), conditionValueSchema).default({}),
  points: z.number().int(),
});

const pricingRulesEnvelopeSchema = apiEnvelope(
  z.array(memberPricingRuleSchema),
);

export type MemberPricingRule = z.infer<typeof memberPricingRuleSchema>;

export interface ListPricingRulesParams {
  modelId: number;
  capability: AiCapability;
}

export function listModelPricingRules(
  params: ListPricingRulesParams,
  signal?: AbortSignal,
) {
  const query = new URLSearchParams({
    modelId: String(params.modelId),
    capability: params.capability,
  });
  return request(`/member/ai/pricing-rules?${query.toString()}`, {
    method: "GET",
    schema: pricingRulesEnvelopeSchema,
    ...(signal ? { signal } : {}),
  });
}
